<template>
  <div>
    <h5 class="sub-title">
      Productos clasificadas de acuerdo con su conducta respiratoria durante ripening
    </h5>
    <div
      class="uk-flex main"
    >
      <table
        id="fruitclassified"
        class="uk-table"
      >
        <thead>
          <tr>
            <th class="title">
              Productos Climatéricas
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="pro in product.selectedProducts.filter(x => x.isClimate)"
            v-show="product?.selectedProducts && product.selectedProducts.filter(x => x.isClimate).length > 0"
            :key="pro.id"
          >
            <td class="uk-text-center">
              <h5>
                <span>{{ pro.label.trim() }}&nbsp;</span>
              </h5>
            </td>
          </tr>
        </tbody>
      </table>

      <table
        id="fruitclassified1"
        class="uk-table"
      >
        <thead>
          <tr>
            <th class="title">
              Productos No Climatéricas
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="pro in product.selectedProducts.filter(x => !x.isClimate)"
            v-show="product?.selectedProducts && product.selectedProducts.filter(x => !x.isClimate).length >= 0"
            :key="pro.id"
          >
            <td
              class="uk-text-center"
            >
              <h5>
                <span
                  class="uk-text-center"
                >{{ pro.description }}&nbsp;
                </span>
              </h5>
            </td>
          </tr>
          <tr v-if="!product.selectedProducts.some(x => !x.isClimate)">
            <td />
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState([
      'product'
    ])
  },
  mounted () {
    // if (!this.product.selectedProducts.some(x => !x.isClimate)) {
    //   this.product.selectedProducts.push({ isClimate: false, description: 20 })
    // }
  }
}
</script>

<style scoped>
.title{
  text-align: center;
}
.main{
  padding: 0px 10px;
  margin: 30px 0px;
}
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  margin: 10px auto;
}
.sub-title{
   background: #002c3f;
  color: #fff;
  padding: 10px;
  text-align: center;
  text-transform: uppercase;
  font-size: 16px !important;
}
tbody {
  background-color: rgba(127, 219, 255, 0.103);
}
thead th{
  background: #014968;
  color: #fff;
  border: 1px solid rgb(168, 167, 167);
}

td, th {
 text-align: left;
 border: 1px solid #dddddd;
 padding: 8px;
 background: white;
}
@media screen and (max-width: 940px ) {
.sub-title{
  font-size: 10px !important;
}
.main{
  flex-wrap: wrap ;
}
*{
  font-size: 10px;
}
th{
  font-size: 10px !important
}
}
</style>
